import React from "react";
import dayjs from "dayjs";
import {
  Card,
  Descriptions,
  Divider,
  Flex,
  Tag,
  Typography,
  theme,
} from "antd";
import type { QuoteData } from "../../quotes/types";

const { Text } = Typography;

const FieldLabel: React.FC<{ text: string }> = ({ text }) => {
  const { token } = theme.useToken();
  return (
    <Text
      style={{
        fontSize: 11,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.07em",
        color: token.colorTextSecondary,
      }}
    >
      {text}
    </Text>
  );
};

interface SelectedQuoteComponentProps {
  selectedQuote: QuoteData;
}

const SelectedQuoteComponent: React.FC<SelectedQuoteComponentProps> = ({
  selectedQuote,
}) => {
  const { token } = theme.useToken();

  return (
    <Card
      title={
        <Flex align="center" gap={8}>
          <Text strong>Cotización Seleccionada</Text>
          <Tag color="blue">COT-{selectedQuote.id_quote}</Tag>
        </Flex>
      }
      style={{
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
        border: `1px solid ${token.colorBorderSecondary}`,
      }}
      styles={{ body: { padding: "20px" } }}
    >
      <Descriptions column={1} size="small" layout="vertical">
        <Descriptions.Item label={<FieldLabel text="Descripción" />}>
          <Text strong>{selectedQuote.description_quote}</Text>
        </Descriptions.Item>
        <Descriptions.Item label={<FieldLabel text="Monto Total" />}>
          <Text
            style={{
              fontSize: 18,
              fontWeight: 800,
              color: token.colorPrimary,
            }}
          >
            ${new Intl.NumberFormat().format(selectedQuote.total_quote)}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label={<FieldLabel text="Fecha" />}>
          {dayjs(selectedQuote.date_quote).format("DD/MM/YYYY")}
        </Descriptions.Item>
        <Descriptions.Item label={<FieldLabel text="Vencimiento" />}>
          {dayjs(selectedQuote.date_expiration).format("DD/MM/YYYY")}
        </Descriptions.Item>
      </Descriptions>

      {selectedQuote.concepts && selectedQuote.concepts.length > 0 && (
        <>
          <Divider style={{ margin: "16px 0" }} />
          <FieldLabel text="Conceptos" />
          <Flex vertical gap={4} style={{ marginTop: 8 }}>
            {selectedQuote.concepts.map((c: any) => (
              <Tag key={c.id_concept} style={{ margin: 0 }}>
                {c.concept_name}
              </Tag>
            ))}
          </Flex>
        </>
      )}
    </Card>
  );
};

export default SelectedQuoteComponent;
